import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/icon-app.png'


const _withScopeId = n => (_pushScopeId("data-v-730314fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between px-6 py-2 bg-white border-b-4 border-indigo-600" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "relative z-10 block w-8 h-8 overflow-hidden rounded-full shadow focus:outline-none avatar-user-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object-cover w-full h-full",
    src: _imports_0,
    alt: "Your avatar"
  })
], -1))

import { useAuthStore } from "@/stores/auth/authStore";
import { useRouter } from "vue-router";
import { ref, onMounted, provide } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

const logout = () => {
  console.error('logout Header')
  authStore.logout();
  localStorage.removeItem('token');
  router.push('/');
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", { class: "flex items-center" }, [
      _createElementVNode("div", { class: "relative" }, [
        _hoisted_3,
        _createElementVNode("div", { class: "absolute right-0 z-20 w-48 py-1 mt-2 bg-white rounded-lg shadow-xl logout-dropdown hidden" }, [
          _createElementVNode("div", {
            class: "flex px-4 py-2 rounded-md text-sm text-gray-700 hover:bg-indigo-600 hover:text-white cursor-pointer",
            onClick: logout
          }, " Log out ")
        ])
      ])
    ])
  ]))
}
}

})